<template>
  <div id="vFooter">
    <div class="container" style="    border-top: 1px solid lightgray; text-align: right;">
      {{setting==null?'':setting.shnm[0].codeName}}&nbsp;{{setting==null?'':setting.shnmEng[0].codeName}}<br />
      地址：<a href="http://web2.ncut.edu.tw/files/11-1000-24.php" target="_blank" title="交通資訊">{{setting==null?'':setting.shAdd[0].codeName}}</a><br />
      電話：{{setting==null?'':setting.contactWindow[0].codeName}}<br /><br />
      <span style="font-size: smaller;">©2021 - 國立勤益科技大學, 建議使用 <font style="color:#ebb10d;">IE 11.0</font>、<font style="color:#ebb10d;">Firefox 36.0+</font>、<font style="color:#ebb10d;">Chrome</font>、<font style="color:#ebb10d;">Safari</font> 瀏覽器</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vfooter',
  computed: {
    setting () {
      return this.$store.getters.getSetting
    }
  },
  methods: {
    login: function () {
      console.log('======login =====' + this.setting)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  text-align: center;
  font-size: 12px;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterView.vue